import { motion } from "framer-motion";
import { VIKSIT_PILLARS } from "@/lib/monuments";
import { Mail } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export default function FooterCTA() {
  return (
    <footer
      data-testid="footer-section"
      className="relative py-16 md:py-20 border-t border-gold/10 bg-obsidian"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        {/* Viksit Bharat pillars */}
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-16">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 font-mono-accent text-[11px] text-gold/80">
              <span>Alignment</span>
              <span className="w-8 h-px bg-gold/40" />
              <span className="text-bone/50">Viksit Bharat</span>
            </div>
            <h3 className="mt-6 font-display text-3xl md:text-5xl text-bone leading-tight">
              For a <em className="text-gold not-italic">Viksit Bharat.</em>
            </h3>
            <p className="mt-6 text-bone/60 leading-relaxed max-w-sm">
              ReplayEra advances foundational national initiatives — a
              civilisational multiplier for policy, education, tourism, and
              unity.
            </p>
          </div>
          <div className="md:col-span-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {VIKSIT_PILLARS.map((p, i) => (
              <motion.div
                key={p.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, ease: EASE, delay: i * 0.08 }}
                className="border-l border-gold/25 pl-5"
                data-testid={`viksit-pillar-${i + 1}`}
              >
                <div className="font-mono-accent text-[10px] text-gold">
                  0{i + 1}
                </div>
                <div className="mt-2 font-display text-2xl text-bone">
                  {p.name}
                </div>
                <div className="mt-2 text-bone/55 text-sm">{p.note}</div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Direct email strip (form is above) */}
        <div className="border-t border-gold/15 pt-8 flex flex-wrap items-center gap-4 font-mono-accent text-[11px] text-bone/60">
          <span className="flex items-center gap-2 text-bone">
            <Mail className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} />
            <a
              href="mailto:contact@replayera.com"
              className="hover:text-gold transition-colors"
              data-testid="footer-mailto"
            >
              contact@replayera.com
            </a>
          </span>
          <span className="w-8 h-px bg-bone/20" />
          <span>Ministry · Institutional · Press</span>
        </div>

        {/* Colophon */}
        <div className="mt-10 flex flex-col md:flex-row md:items-center justify-between gap-6 font-mono-accent text-[10px] text-bone/40">
          <div className="flex items-center gap-3">
            <span className="w-6 h-6 border border-gold/40 rounded-full grid place-items-center">
              <span className="w-1.5 h-1.5 rounded-full bg-gold" />
            </span>
            ReplayEra · Bharat
          </div>
          <div className="flex flex-wrap items-center gap-5">
            <span>Reimagining Heritage Tourism</span>
            <span>·</span>
            <span>A National Mission</span>
            <span>·</span>
            <span>© All rights reserved</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
